import { useState } from 'react'

import { useMemoizedFn } from 'ahooks'
import { $getSelection } from 'lexical'

import { $getTableCellNodes } from '../../utils/table'
import { useEditor } from '../useEditor'
import { useSelectionChange } from '../useSelectionChange'

export type VerticalAlignType = 'top' | 'moddle' | 'bottom'

export const useTableVerticalAlign = () => {
  const editor = useEditor()
  const [verticalAlign, _setVerticalAlign] = useState<VerticalAlignType>('top')

  const getVerticalAlignHandler = () => {
    const tableCellNode = $getTableCellNodes($getSelection())[0]
    if (!tableCellNode) return
    let verticalAlign = tableCellNode.getVerticalAlign()
    if (!verticalAlign) {
      const tdEl = editor.getElementByKey(tableCellNode.getKey())
      if (tdEl) {
        verticalAlign = getComputedStyle(tdEl).verticalAlign
      }
    }
    _setVerticalAlign((verticalAlign || 'top') as VerticalAlignType)
    return false
  }

  useSelectionChange(getVerticalAlignHandler)

  const setVerticalAlign = useMemoizedFn(
    (verticalFormat: VerticalAlignType) => {
      _setVerticalAlign(verticalFormat)
      editor.update(() => {
        const selection = $getSelection()
        const cellNodes = $getTableCellNodes(selection)
        for (const cellNode of cellNodes) {
          cellNode.setVerticalAlign(verticalFormat)
        }
      })
    }
  )

  return [verticalAlign, setVerticalAlign] as const
}
